<template>
    <div class="posPrintSet">
        <div class="main-flex">
            <edit-btns class="btn-box" 
                :bnts="['save','goBack']"
                @saveClick="saveData()"
                @goBackClick="$router.back()"/>
        </div>
        <div class="content-box">
            <div class="panel-box">
                <div class="panel-heading">打印机分配——{{siteName}}
                    <div class="tr-li">
                        <el-checkbox v-model="Is_ServicePrint" label="本站点不支持直接打印，按后台打印服务打印" size="large"></el-checkbox>
                    </div>
                    <div class="tr-li">
                        <select-tree class="selectPrint" 
                            v-model="batchPrint" isButton title="请选择打印机"
                            @change="batchChange"
                            :isMultiple="false" :data="printersTree">[批量打印机]</select-tree>
                    </div>
                </div>
                <div class="panel-body">
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_KKPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印客看单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="KK_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in KK_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="KK_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="KK_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_XFPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印消费单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="XF_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in XF_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="XF_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="XF_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_JZPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印结账单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="JZ_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in JZ_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="JZ_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="JZ_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_JBPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印结班单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="JB_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in JB_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="JB_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="JB_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_RJPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印日结单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="RJ_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in RJ_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="RJ_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="RJ_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_KDSPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印KDS核销单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="KDS_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in KDS_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="KDS_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="KDS_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_PCPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印配菜单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="PC_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in PC_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="PC_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="PC_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_BKPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印办卡" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="BK_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in BK_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="BK_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="BK_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_CZPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印卡充值" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="CZ_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in CZ_printModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="CZ_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="CZ_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_CFZDPrint" class="mb-2" :inline-prompt="true" active-text="本站点快餐结账时，直打厨房单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">出单类型：</div>
                                <div class="from-input">
                                    <el-select v-model="CFZD_DetailInfo.Print_TemplateID" multiple collapse-tags placeholder="请选择出单类型">
                                        <el-option :value="item.Eat_IssueAutoID" :label="item.Eat_IssueName" v-for="item in kitIssuingTypes" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="CFZD_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="CFZD_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_ARClearPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印AR清账单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="ArClear_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in AR_ClarePrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="ArClear_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="ArClear_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_ARClearRecharge" class="mb-2" :inline-prompt="true" active-text="本站点打印AR预付充值单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="ArRecharge_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in CZ_RechargePrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="ArRecharge_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="ArRecharge_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_YDXFBMPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印预排菜单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="YDXFBM_DetailInfo.Print_ModelID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in YDXFBMPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="YDXFBM_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="YDXFBM_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">出单类型：</div>
                                <div class="from-input">
                                    <el-select v-model="YDXFBM_DetailInfo.Print_TemplateID" multiple collapse-tags placeholder="请选择出单类型">
                                        <el-option :value="item.Eat_IssueAutoID" :label="item.Eat_IssueName" v-for="item in kitIssuingTypes" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_DepositPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印押金单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="Deposit_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in DepositPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="Deposit_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="Deposit_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_RefundCadPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印退卡单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="RefundCad_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in RefundCadPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="RefundCad_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="RefundCad_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_QHXPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印核销券单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="QHX_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in QHXPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="QHX_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="QHX_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_ZCPrint" class="mb-2" :inline-prompt="true" active-text="本站点打印暂存单" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="ZC_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in ZCPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="ZC_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="ZC_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_SGPrint" class="mb-2" :inline-prompt="true" active-text="本站点手工开票" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="SG_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in SGPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="SG_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="SG_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="tr-li">
                        <div class="tr-title">
                            <el-switch v-model="IS_KZCPrint" class="mb-2" :inline-prompt="true" active-text="本站点卡资产调整" inactive-text=""></el-switch>
                        </div>
                        <el-row class="flex1">
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">打印模板：</div>
                                <div class="from-input">
                                    <el-select v-model="KZC_DetailInfo.Print_TemplateID" placeholder="请选择打印模板">
                                        <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in KZCPrintModels" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="9" :lg="8" :xl="6">
                                <div class="lable-txt">选择打印机：</div>
                                <div class="from-input">
                                    <el-select v-model="KZC_DetailInfo.Printer_ID" placeholder="请选择打印机">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="5">
                                <div class="lable-txt">打印份数：</div>
                                <div class="from-input"><inputPattern v-model="KZC_DetailInfo.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"></inputPattern></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="table-box">
                        <div class="title">
                            <el-switch v-model="IS_KitChannelPrint" class="mb-2" :inline-prompt="true" active-text="本站点快餐结账时，按渠道打印厨房单" inactive-text=""></el-switch>
                        </div>
                        <el-table class="el-table--scrollable-y" v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}"
                            border
                            :data="KitChannelPrint_Details"
                            highlight-current-row
                            ref="tableEl">
                            <el-table-column type="index" label="序号" width="50" align="center"/>
                            <el-table-column label="操作" width="70" align="center">
                                <template #default="scope">
                                    <div class="operation">
                                        <b class="iconfont icon-jia" @click="add(KitChannelPrint_Details,scope.$index)"></b>
                                        <b class="iconfont icon-jian" @click="del(KitChannelPrint_Details,scope.$index)"></b>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="订单渠道" min-width="200" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row.Channel_Ids" multiple collapse-tags placeholder="请选择订单渠道" @focus="$refs.tableEl?.setCurrentRow(scope.row)">
                                        <el-option :value="item.id" :label="item.name" v-for="item in orderChannelList" :key="item"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="出单类型" min-width="200" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row.KitIssueType_Ids" multiple collapse-tags placeholder="请选择出单类型">
                                        <el-option :value="item.Eat_IssueAutoID" :label="item.Eat_IssueName" v-for="item in kitIssuingTypes" :key="item"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="打印机" min-width="200" align="center">
                                <template #default="scope">
                                    <el-select v-model="scope.row.Printer_ID" placeholder="请选择打印机"  @focus="$refs.tableEl?.setCurrentRow(scope.row)">
                                        <el-option :value="item.Printer_AutoID" :label="item.Printer_Name" v-for="item in printers" :key="item"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="打印份数" width="100" align="center">
                                <template #default="scope">
                                    <div class="from-input">
                                        <inputPattern v-model="scope.row.Print_Num" type="number" pattern="number" :min="1" :dplaces="0"/>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
/**站点打印机分配 */
export default {
    name:"posPrintSet",
    data(){
        return {
            //设备名称
            siteName:"",
            //主键
            Assigned_ID:'',
            //是否不直接打印，由服务打印
            Is_ServicePrint:false,
            IS_KKPrint:false,
            //渠道数据
            orderChannel:null,
            /**客看单 */
            KK_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_XFPrint:false,
            /**消费单 */
            XF_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_JZPrint:false,
            /**结账单 */
            JZ_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'', 
                Print_Num:1
            },
            IS_JBPrint:false,
            /**结班单 */
            JB_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_RJPrint:false,
            /**日结单 */
            RJ_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_KDSPrint:false,
            /**本站点打印KDS核销单 */
            KDS_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_PCPrint:false,
            /**配菜单 */
            PC_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_BKPrint:false,
            /**本站点打印办卡 */
            BK_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_CZPrint:false,
            /**本站点打印卡充值 */
            CZ_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_CFZDPrint:false,
            /**本站点快餐结账时，直打厨房单 */
            CFZD_DetailInfo:{
                Print_TemplateID:[],
                Printer_ID:'',
                Print_Num:1
            },
            IS_ARClearPrint:false,
            /**本站点打印AR清账单 */
            ArClear_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            IS_ARClearRecharge:false,
            /**本站点打印AR预付充值单 */
            ArRecharge_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点打印预排菜单 */
            IS_YDXFBMPrint:false,
            YDXFBM_DetailInfo:{
                Print_TemplateID:[],
                Print_ModelID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点打印押金单 */
            IS_DepositPrint:false,
            Deposit_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点打印退卡单 */
            IS_RefundCadPrint:false,
            RefundCad_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点打印核销券单 */
            IS_QHXPrint:false,
            QHX_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点打印暂存单 */
            IS_ZCPrint:false,
            ZC_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点手工开票 */
            IS_SGPrint:false,
            SG_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点卡资产调整 */
            IS_KZCPrint:false,
            KZC_DetailInfo:{
                Print_TemplateID:'',
                Printer_ID:'',
                Print_Num:1
            },
            /**本站点快餐结账时，按渠道打印厨房单 */
            IS_KitChannelPrint:false,
            KitChannelPrint_Details:[{}],
            printers:[],
            printModels:[],
            //厨房出单类型数据
            kitIssuingTypes:[],
            //批量打印机
            batchPrint:null,
            
        };
    },
    computed:{
        //渠道数据
        orderChannelList(){
            let treeData=[];
            this.orderChannel?.forEach((group)=>{
                group.OrderChannelList?.forEach(item=>{
                    let children= Object.assign({
                        id:item.OrderChannel_AutoID,
                        name:item.OrderChannel_Code+'-'+item.OrderChannel_Name,
                    },item)
                    treeData.push(children)
                })
            })
            return treeData;
        },
        //客看单 模板 
        KK_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==8);
        },
        //消费单 模板
        XF_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==1);
        },
        //结账单 模板
        JZ_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==2);
        },
        //结班单 模板
        JB_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==9);
        },
        //日结单 模板
        RJ_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==10);
        },
        //KDS核销单 模板
        KDS_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==801);
        },
        //配菜单 模板
        PC_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==11);
        },
        //办卡 模板
        BK_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==51);
        },
        //充值 模板
        CZ_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==52);
        },
        //AR清账打印模板
        AR_ClarePrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==9011);
        },
        //AR预付款打印模板
        CZ_RechargePrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==9012);
        },
        //本站点打印预排菜单 打印模板
        YDXFBMPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==801);
        },
        //本站打印押金单 打印模板
        DepositPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==903);
        },
        //本站点打印退卡单 打印模板
        RefundCadPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==53);
        },
        //本站点打印核销券单 打印模板
        QHXPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==904);
        },
        //本站点打印暂存单 打印模板
        ZCPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==905);
        },
        //本站点手工开票 打印模板
        SGPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==906);
        },
        //本站点卡资产调整 打印模板
        KZCPrintModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==54);
        },
        /**打印机tree 结构 */
        printersTree(){
            let data=[]
            this.printers?.forEach(it=>{
                data.push({
                    id:it.Printer_AutoID,
                    name:it.Printer_Name
                })
            })
            return data;
        }
    },
    mounted(){
        this.$emit("navIndex",4);
        this.loadBaseData();
        let userInfo= this.$auth.getUserInfo();
        if(userInfo){
            this.siteName=userInfo.Site_Name;
        }
        this.loadPosPrintModuleNote();
    },
    methods:{
        /**批量选择打印机 */
        batchChange(Printer_ID){
            this.KK_DetailInfo.Printer_ID=Printer_ID;//客看单
            this.XF_DetailInfo.Printer_ID=Printer_ID;//消费单
            this.JZ_DetailInfo.Printer_ID=Printer_ID;//结账单
            this.JB_DetailInfo.Printer_ID=Printer_ID;//结班单
            this.RJ_DetailInfo.Printer_ID=Printer_ID;//日结单
            this.KDS_DetailInfo.Printer_ID=Printer_ID;//本站点打印KDS核销单
            this.PC_DetailInfo.Printer_ID=Printer_ID;//配菜单
            this.BK_DetailInfo.Printer_ID=Printer_ID;//本站点打印办卡
            this.CZ_DetailInfo.Printer_ID=Printer_ID;//本站点打印卡充值
            this.CFZD_DetailInfo.Printer_ID=Printer_ID;//本站点快餐结账时，直打厨房单
            this.ArClear_DetailInfo.Printer_ID=Printer_ID;//本站点打印AR清账单
            this.ArRecharge_DetailInfo.Printer_ID=Printer_ID;//本站点打印AR预付充值单
            this.YDXFBM_DetailInfo.Printer_ID=Printer_ID;//本站点打印预排菜单
            this.Deposit_DetailInfo.Printer_ID=Printer_ID;//本站点打印押金单
            this.RefundCad_DetailInfo.Printer_ID=Printer_ID;//本站点打印退卡单
            this.QHX_DetailInfo.Printer_ID=Printer_ID;//本站点打印核销券单
            this.ZC_DetailInfo.Printer_ID=Printer_ID;//本站点打印暂存单
            this.SG_DetailInfo.Printer_ID=Printer_ID;//本站点手工开票
            this.KZC_DetailInfo.Printer_ID=Printer_ID;//本站点卡资产调整
            //本站点快餐结账时，按渠道打印厨房单
            this.KitChannelPrint_Details?.forEach(it=>{
                it.Printer_ID=Printer_ID;
            })
        },
        loadBaseData(){
            this.$cacheData.Printers().then((d)=>{
                this.printers=d;
            }).catch(e=>{
                console.log('打印机数据获取失败e:'+e)
            })
            this.$cacheData.PrintModels().then(d=>{
                this.printModels=d?.map(it=>{
                    let json=Object.assign({},it);
                    if(json.IsGroup){
                        json.PrintModel_Name='【区域】-'+json.PrintModel_Name;
                    }else if(json.IsPublic){
                        json.PrintModel_Name='【公有】-'+json.PrintModel_Name;
                    }else{
                        json.PrintModel_Name='【私有】-'+json.PrintModel_Name;
                    }
                    return json;
                })
            }).catch(e=>{
                console.log('打印模板数据获取失败e:'+e)
            });
            this.$cacheData.KitIssuingTypes().then((d)=>{
                this.kitIssuingTypes=d;
                console.log(d)
            }).catch(e=>{
                console.log('厨房出单类型数据获取失败e:'+e)
            })
            //渠道数据
            this.$cacheData.OrderChannel().then((d)=>{
                if(d){
                    this.orderChannel=d;
                }
            }).catch((e)=>{
                this.$message.error('加载渠道数据失败：'+e.message);
                console.log('加载渠道数据失败：'+e);
            })
        },
        //站点打印机分配数据
        loadPosPrintModuleNote(){
            const loading = this.$loading({
                text: "加载站点打印机分配数据...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetSTKEquipmentPrintInfo",{ }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    let info=d.ResponseBody||{};
                    if(info){
                        this.Assigned_ID=info.Assigned_ID;
                        this.Is_ServicePrint=info.Is_ServicePrint;
                        if(info.KK_DetailInfo){
                            this.IS_KKPrint=true;
                            this.KK_DetailInfo=info.KK_DetailInfo;
                        }
                        if(info.XF_DetailInfo){
                            this.IS_XFPrint=true;
                            this.XF_DetailInfo=info.XF_DetailInfo;
                        }
                        if(info.JZ_DetailInfo){
                            this.IS_JZPrint=true;
                            this.JZ_DetailInfo=info.JZ_DetailInfo;
                        }
                        if(info.JB_DetailInfo){
                            this.IS_JBPrint=true;
                            this.JB_DetailInfo=info.JB_DetailInfo;
                        }
                        if(info.RJ_DetailInfo){
                            this.IS_RJPrint=true;
                            this.RJ_DetailInfo=info.RJ_DetailInfo;
                        }
                        if(info.KDS_DetailInfo){
                            this.IS_KDSPrint=true;
                            this.KDS_DetailInfo = info.KDS_DetailInfo;
                        }
                        if(info.PC_DetailInfo){
                            this.IS_PCPrint=true;
                            this.PC_DetailInfo = info.PC_DetailInfo;
                        }
                        if(info.BK_DetailInfo){
                            this.IS_BKPrint=true;
                            this.BK_DetailInfo = info.BK_DetailInfo;
                        }
                        if(info.CZ_DetailInfo){
                            this.IS_CZPrint=true;
                            this.CZ_DetailInfo = info.CZ_DetailInfo;
                        }
                        if(info.CFZD_DetailInfo){
                            this.IS_CFZDPrint=true;
                            this.CFZD_DetailInfo = info.CFZD_DetailInfo;
                        }
                        if(info.ArClear_DetailInfo){
                            this.IS_ARClearPrint=true;
                            this.ArClear_DetailInfo = info.ArClear_DetailInfo;
                        }
                        if(info.ArRecharge_DetailInfo){
                            this.IS_ARClearRecharge=true;
                            this.ArRecharge_DetailInfo = info.ArRecharge_DetailInfo;
                        }
                        if(info.YDXFBM_DetailInfo){//本站点打印预排菜单
                            this.IS_YDXFBMPrint=true;
                            this.YDXFBM_DetailInfo = info.YDXFBM_DetailInfo;
                        }

                        if(info.Deposit_DetailInfo){//本站点打印押金单
                            this.IS_DepositPrint=true;
                            this.Deposit_DetailInfo = info.Deposit_DetailInfo;
                        }

                        if(info.RefundCad_DetailInfo){//本站点打印退卡单
                            this.IS_RefundCadPrint=true;
                            this.RefundCad_DetailInfo = info.RefundCad_DetailInfo;
                        }

                        if(info.QHX_DetailInfo){//本站点打印核销券单
                            this.IS_QHXPrint=true;
                            this.QHX_DetailInfo = info.QHX_DetailInfo;
                        }

                        if(info.ZC_DetailInfo){//本站点打印暂存单
                            this.IS_ZCPrint=true;
                            this.ZC_DetailInfo = info.ZC_DetailInfo;
                        }

                        if(info.SG_DetailInfo){//本站点手工开票
                            this.IS_SGPrint=true;
                            this.SG_DetailInfo = info.SG_DetailInfo;
                        }

                        if(info.KZC_DetailInfo){//本站点卡资产调整
                            this.IS_KZCPrint=true;
                            this.KZC_DetailInfo = info.KZC_DetailInfo;
                        }

                        if(info.KitChannelPrint_Details){//本站点快餐结账时，按渠道打印厨房单
                            this.IS_KitChannelPrint=true;
                            this.KitChannelPrint_Details = info.KitChannelPrint_Details;
                        }else{
                            this.IS_KitChannelPrint=false;
                            this.KitChannelPrint_Details=[];
                            this.add(this.KitChannelPrint_Details,0);
                        }
                    }
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('未找到站点打印机分配数据：'+e);
                console.log('未找到站点打印机分配数据：'+e);
            })
        },
        /**保存数据 */
        saveData(){
            
            let info={
                Assigned_ID:this.Assigned_ID,
                Is_ServicePrint:this.Is_ServicePrint
            }
            if(this.IS_KKPrint){
                info.KK_DetailInfo=this.KK_DetailInfo;
                if(!this.KK_DetailInfo.Print_TemplateID){
                    this.$message.warning('客看单打印模板未设置！');
                    return;
                }
                if(!this.KK_DetailInfo.Printer_ID){
                    this.$message.warning('客看单打印机未设置！');
                    return;
                }
                if(!(this.KK_DetailInfo.Print_Num>0)){
                    this.$message.warning('客看单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_XFPrint){
                info.XF_DetailInfo=this.XF_DetailInfo;
                if(!this.XF_DetailInfo.Print_TemplateID){
                    this.$message.warning('消费单打印模板未设置！');
                    return;
                }
                if(!this.XF_DetailInfo.Printer_ID){
                    this.$message.warning('消费单打印机未设置！');
                    return;
                }
                if(!(this.XF_DetailInfo.Print_Num>0)){
                    this.$message.warning('消费单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_JZPrint){
                info.JZ_DetailInfo=this.JZ_DetailInfo;
                if(!this.JZ_DetailInfo.Print_TemplateID){
                    this.$message.warning('结账单打印模板未设置！');
                    return;
                }
                if(!this.JZ_DetailInfo.Printer_ID){
                    this.$message.warning('结账单打印机未设置！');
                    return;
                }
                if(!(this.JZ_DetailInfo.Print_Num>0)){
                    this.$message.warning('结账单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_JBPrint){
                info.JB_DetailInfo=this.JB_DetailInfo;
                if(!this.JB_DetailInfo.Print_TemplateID){
                    this.$message.warning('结班单打印模板未设置！');
                    return;
                }
                if(!this.JB_DetailInfo.Printer_ID){
                    this.$message.warning('结班单打印机未设置！');
                    return;
                }
                if(!(this.JB_DetailInfo.Print_Num>0)){
                    this.$message.warning('结班单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_RJPrint){
                info.RJ_DetailInfo=this.RJ_DetailInfo;
                if(!this.RJ_DetailInfo.Print_TemplateID){
                    this.$message.warning('日结单打印模板未设置！');
                    return;
                }
                if(!this.RJ_DetailInfo.Printer_ID){
                    this.$message.warning('日结单打印机未设置！');
                    return;
                }
                if(!(this.RJ_DetailInfo.Print_Num>0)){
                    this.$message.warning('日结单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_KDSPrint){
                info.KDS_DetailInfo = this.KDS_DetailInfo;
                if(!this.KDS_DetailInfo.Print_TemplateID){
                    this.$message.warning('KDS核销单打印模板未设置！');
                    return;
                }
                if(!this.KDS_DetailInfo.Printer_ID){
                    this.$message.warning('KDS核销单打印机未设置！');
                    return;
                }
                if(!(this.KDS_DetailInfo.Print_Num>0)){
                    this.$message.warning('KDS核销单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_PCPrint){
                info.PC_DetailInfo = this.PC_DetailInfo;
                if(!this.PC_DetailInfo.Print_TemplateID){
                    this.$message.warning('配菜单打印模板未设置！');
                    return;
                }
                if(!this.PC_DetailInfo.Printer_ID){
                    this.$message.warning('配菜单打印机未设置！');
                    return;
                }
                if(!(this.PC_DetailInfo.Print_Num>0)){
                    this.$message.warning('配菜单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_BKPrint){
                info.BK_DetailInfo = this.BK_DetailInfo;
                if(!this.BK_DetailInfo.Print_TemplateID){
                    this.$message.warning('办卡打印模板未设置！');
                    return;
                }
                if(!this.BK_DetailInfo.Printer_ID){
                    this.$message.warning('办卡打印机未设置！');
                    return;
                }
                if(!(this.BK_DetailInfo.Print_Num>0)){
                    this.$message.warning('办卡打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_CZPrint){
                info.CZ_DetailInfo = this.CZ_DetailInfo;
                if(!this.CZ_DetailInfo.Print_TemplateID){
                    this.$message.warning('充值打印模板未设置！');
                    return;
                }
                if(!this.CZ_DetailInfo.Printer_ID){
                    this.$message.warning('充值打印机未设置！');
                    return;
                }
                if(!(this.CZ_DetailInfo.Print_Num>0)){
                    this.$message.warning('充值打印份数必须大于0！');
                    return;
                }
            }

            if(this.IS_CFZDPrint){
                info.CFZD_DetailInfo = this.CFZD_DetailInfo;
                if(!(this.CFZD_DetailInfo.Print_TemplateID?.length>0)){
                    this.$message.warning('直打厨房单出单类型未设置！');
                    return;
                }
                if(!this.CFZD_DetailInfo.Printer_ID){
                    this.$message.warning('直打厨房单打印机未设置！');
                    return;
                }
                if(!(this.CFZD_DetailInfo.Print_Num>0)){
                    this.$message.warning('直打厨房单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_ARClearPrint){
                info.ArClear_DetailInfo = this.ArClear_DetailInfo;
                if(!this.ArClear_DetailInfo.Print_TemplateID){
                    this.$message.warning('AR清账单出单打印模板未设置！');
                    return;
                }
                if(!this.ArClear_DetailInfo.Printer_ID){
                    this.$message.warning('AR清账单打印机未设置！');
                    return;
                }
                if(!(this.ArClear_DetailInfo.Print_Num>0)){
                    this.$message.warning('AR清账单打印份数必须大于0！');
                    return;
                }
            }
            if(this.IS_ARClearRecharge){
                info.ArRecharge_DetailInfo = this.ArRecharge_DetailInfo;
                if(!this.ArRecharge_DetailInfo.Print_TemplateID){
                    this.$message.warning('AR预付充值单打印模板未设置！');
                    return;
                }
                if(!this.ArRecharge_DetailInfo.Printer_ID){
                    this.$message.warning('AR预付充值单打印机未设置！');
                    return;
                }
                if(!(this.ArRecharge_DetailInfo.Print_Num>0)){
                    this.$message.warning('AR预付充值单打印份数必须大于0！');
                    return;
                }
            }

            if(this.IS_YDXFBMPrint){//本站点打印预排菜单
                info.YDXFBM_DetailInfo = this.YDXFBM_DetailInfo;
                if(!(this.YDXFBM_DetailInfo.Print_TemplateID?.length>0)){
                    this.$message.warning('预排菜单出单类型未设置！');
                    return;
                }
                if(!this.YDXFBM_DetailInfo.Print_ModelID){
                    this.$message.warning('预排菜单打印模板未设置！');
                    return;
                }
                if(!this.YDXFBM_DetailInfo.Printer_ID){
                    this.$message.warning('预排菜单打印机未设置！');
                    return;
                }
                if(!(this.YDXFBM_DetailInfo.Print_Num>0)){
                    this.$message.warning('预排菜单打印份数必须大于0！');
                    return;
                }
            }

            if(this.IS_DepositPrint){
                info.Deposit_DetailInfo = this.Deposit_DetailInfo;
                if(!this.Deposit_DetailInfo.Print_TemplateID){
                    this.$message.warning('打印押金单打印模板未设置！');
                    return;
                }
                if(!this.Deposit_DetailInfo.Printer_ID){
                    this.$message.warning('打印押金单打印机未设置！');
                    return;
                }
                if(!(this.Deposit_DetailInfo.Print_Num>0)){
                    this.$message.warning('打印押金单打印份数必须大于0！');
                    return;
                }
            }

            if(this.IS_RefundCadPrint){
                info.RefundCad_DetailInfo = this.RefundCad_DetailInfo;
                if(!this.RefundCad_DetailInfo.Print_TemplateID){
                    this.$message.warning('打印退卡单打印模板未设置！');
                    return;
                }
                if(!this.RefundCad_DetailInfo.Printer_ID){
                    this.$message.warning('打印退卡单打印机未设置！');
                    return;
                }
                if(!(this.RefundCad_DetailInfo.Print_Num>0)){
                    this.$message.warning('打印退卡单打印份数必须大于0！');
                    return;
                }
            }

            if(this.IS_QHXPrint){
                info.QHX_DetailInfo = this.QHX_DetailInfo;
                if(!this.QHX_DetailInfo.Print_TemplateID){
                    this.$message.warning('打印核销券单打印模板未设置！');
                    return;
                }
                if(!this.QHX_DetailInfo.Printer_ID){
                    this.$message.warning('打印核销券单打印机未设置！');
                    return;
                }
                if(!(this.QHX_DetailInfo.Print_Num>0)){
                    this.$message.warning('打印核销券单打印份数必须大于0！');
                    return;
                }
            }

            if(this.IS_ZCPrint){
                info.ZC_DetailInfo = this.ZC_DetailInfo;
                if(!this.ZC_DetailInfo.Print_TemplateID){
                    this.$message.warning('打印暂存单打印模板未设置！');
                    return;
                }
                if(!this.ZC_DetailInfo.Printer_ID){
                    this.$message.warning('打印暂存单打印机未设置！');
                    return;
                }
                if(!(this.ZC_DetailInfo.Print_Num>0)){
                    this.$message.warning('打印暂存单打印份数必须大于0！');
                    return;
                }
            }
            //本站点手工开票
            if(this.IS_SGPrint){
                info.SG_DetailInfo = this.SG_DetailInfo;
                if(!this.SG_DetailInfo.Print_TemplateID){
                    this.$message.warning('手工开票打印模板未设置！');
                    return;
                }
                if(!this.SG_DetailInfo.Printer_ID){
                    this.$message.warning('手工开票打印机未设置！');
                    return;
                }
                if(!(this.SG_DetailInfo.Print_Num>0)){
                    this.$message.warning('手工开票打印份数必须大于0！');
                    return;
                }
            }
            //本站点卡资产调整
            if(this.IS_KZCPrint){
                info.KZC_DetailInfo = this.KZC_DetailInfo;
                if(!this.KZC_DetailInfo.Print_TemplateID){
                    this.$message.warning('卡资产调整打印模板未设置！');
                    return;
                }
                if(!this.KZC_DetailInfo.Printer_ID){
                    this.$message.warning('卡资产调整打印机未设置！');
                    return;
                }
                if(!(this.KZC_DetailInfo.Print_Num>0)){
                    this.$message.warning('卡资产调整打印份数必须大于0！');
                    return;
                }
            }
            //本站点快餐结账时，按渠道打印厨房单
            if(this.IS_KitChannelPrint){
                try {
                    this.KitChannelPrint_Details?.forEach(it=>{
                        if(!(it.Channel_Ids?.length>0)){
                           throw '快餐结账时，按渠道打印厨房单订单渠道未设置！';
                        }
                        if(!(it.KitIssueType_Ids?.length>0)){
                           throw '快餐结账时，按渠道打印厨房单出单类型未设置！';
                        }
                        if(!it.Printer_ID){
                            throw '快餐结账时，按渠道打印厨房单打印机未设置！';
                        }
                        if(!(it.Print_Num>0)){
                            throw '快餐结账时，按渠道打印厨房单打印份数必须大于0！'
                        }
                    })
                } catch (error) {
                    this.$message.warning(error);
                    return;
                }
                info.KitChannelPrint_Details=this.KitChannelPrint_Details;
            }
            const loading = this.$loading({
                text: "数据保存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.SaveEquipmentPrintInfo",{
                EquipmentPrintInfo:info,
                Operator_Name:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("保存成功");
                    if(!this.IS_KKPrint){
                        this.KK_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_XFPrint){
                        this.XF_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_JZPrint){
                        this.JZ_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_JBPrint){
                        this.JB_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_RJPrint){
                        this.RJ_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_KDSPrint){
                        this.KDS_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_PCPrint){
                        this.PC_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_BKPrint){
                        this.BK_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_CZPrint){
                        this.CZ_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_CFZDPrint){
                        this.CFZD_DetailInfo={
                            Print_TemplateID:[],
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_ARClearPrint){
                        this.ArClear_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }
                    if(!this.IS_ARClearRecharge){
                        this.ArRecharge_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_YDXFBMPrint){
                        this.YDXFBM_DetailInfo={
                            Print_TemplateID:[],
                            Print_ModelID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_DepositPrint){
                        this.Deposit_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_RefundCadPrint){
                        this.RefundCad_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_QHXPrint){
                        this.QHX_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_ZCPrint){
                        this.ZC_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_SGPrint){
                        this.SG_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_KZCPrint){
                        this.KZC_DetailInfo={
                            Print_TemplateID:'',
                            Printer_ID:'',
                            Print_Num:1
                        }
                    }

                    if(!this.IS_KitChannelPrint){
                        this.KitChannelPrint_Details=[]
                        this.add(this.KitChannelPrint_Details,0);
                    }
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('站点打印机分配数据保存失败：'+e);
                console.log('站点打印机分配数据保存失败：'+e);
            })
        },
        add(table,index){
            if(!table) return;
            table.splice(index+1,0,{Print_Num:1});
        },
        del(table,index){
            if(!table) return;
            table.splice(index,1);
            if(table.length==0){
                this.add(table,0)
            }
        }
    }

}
</script>

<style lang="scss">
@import './posPrintSet.scss'
</style>